/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateEntityNote
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateEntityNote } from 'app-constants/queryKeys';

/**
 * Mutate for update entity note
 *
 */
const useUpdateEntityNote = (): UseMutationResult<unknown, IAxiosError, NotePatchModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.NoteApi.patchEntityNote(model);
		},
		onSuccess: () => {
			setTimeout(() => {
				invalidateEntityNote(queryClient);
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateEntityNote;
